import { render, staticRenderFns } from "./LeftArea.vue?vue&type=template&id=4019ca90"
import script from "./LeftArea.vue?vue&type=script&lang=js"
export * from "./LeftArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports